"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64UrlEncode = void 0;
function base64UrlEncode(string) {
    var base64Characters = { '+': '-', '/': '_', '=': '' };
    return string.replace(/[+/=]/g, function (m) { return base64Characters[m]; });
}
exports.base64UrlEncode = base64UrlEncode;
//# sourceMappingURL=base64UrlEncode.js.map